import { render } from "./CreateShoppingList.vue?vue&type=template&id=5fd2fc1c&ts=true"
import script from "./CreateShoppingList.vue?vue&type=script&lang=ts"
export * from "./CreateShoppingList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/tobias/Projects/MontyBuy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__